import { Badge } from '../../components/ui/badge';

const CONFIG = {
  New: { label: 'NEW', className: 'bg-blue-100 text-blue-700 hover:bg-blue-100' },
  Renewal: { label: 'RENEWAL', className: 'bg-green-100 text-green-700 hover:bg-green-100' },
  Unverified: { label: 'UNVERIFIED', className: 'bg-amber-100 text-amber-700 hover:bg-amber-100' },
  NotTracked: { label: 'Not Tracked', className: 'bg-slate-100 text-slate-500 hover:bg-slate-100' },
};

export function EnrollmentTypeBadge({ type }) {
  const cfg = CONFIG[type] || CONFIG.Unverified;
  return <Badge className={`font-semibold ${cfg.className}`}>{cfg.label}</Badge>;
}
